import React, { useEffect, useState } from "react";
import { GetAssignedFacilitiesList } from "adminApi/AssignRoomFacilitiesApi/AssignRoomFacilities";

const RoomFacilitiesCheckboxGroup = ({ values, setValues, facilityOptions = [] }) => {
    const [selectedFacilities, setSelectedFacilities] = useState([]);
    const [loadingAssigned, setLoadingAssigned] = useState(false);

    // Fetch assigned facilities only when room_type changes
    // facilityOptions intentionally excluded from deps — changing the list
    // should not reset user selections or re-trigger the API call
    useEffect(() => {
        if (!values.room_type && values.room_type !== 0) {
            setSelectedFacilities([]);
            setValues((prev) => ({ ...prev, facility_id: [] }));
            return;
        }

        let mounted = true;

        const fetchAssigned = async () => {
            setLoadingAssigned(true);
            try {
                const assigned = await GetAssignedFacilitiesList(values.room_type);
                const assignedData = assigned?.data?.data || [];
                const assignedIds = assignedData.map((item) => item.facility_id);

                if (mounted) {
                    setSelectedFacilities(assignedIds);
                    setValues((prev) => ({ ...prev, facility_id: assignedIds }));
                }
            } catch (error) {
                console.error("Error fetching assigned facilities:", error);
            } finally {
                if (mounted) setLoadingAssigned(false);
            }
        };

        fetchAssigned();
        return () => { mounted = false; };
    }, [values.room_type]); // eslint-disable-line react-hooks/exhaustive-deps

    const toggleFacility = (id) => {
        const updated = selectedFacilities.includes(id)
            ? selectedFacilities.filter((fid) => fid !== id)
            : [...selectedFacilities, id];

        setSelectedFacilities(updated);
        setValues((prev) => ({ ...prev, facility_id: updated }));
    };

    if (loadingAssigned) {
        return (
            <div className="col-12 text-center py-3 text-muted">
                <div className="spinner-border spinner-border-sm me-2" role="status" />
                Loading assigned facilities...
            </div>
        );
    }

    if (facilityOptions.length === 0) {
        return (
            <div className="col-12 text-center py-3 text-muted">
                No facilities available.
            </div>
        );
    }

    return (
        <div className="row g-3">
            {facilityOptions.map((facility) => (
                <div
                    key={facility.facilitytypeid}
                    className="col-md-4 col-lg-3 col-xxl-2 col-sm-6 col-12"
                >
                    <div className="form-check p-3 border rounded-3 shadow-sm h-100 d-flex align-items-center">
                        <input
                            id={`facility-${facility.facilitytypeid}`}
                            type="checkbox"
                            className="form-check-input me-3"
                            checked={selectedFacilities.includes(facility.facilitytypeid)}
                            onChange={() => toggleFacility(facility.facilitytypeid)}
                        />
                        <label
                            htmlFor={`facility-${facility.facilitytypeid}`}
                            className="form-check-label mb-0 fw-medium"
                        >
                            {facility.facilitytypetitle}
                        </label>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default RoomFacilitiesCheckboxGroup;
